<template>
  <div
    class="fixed left-0 top-0 bg-overlay w-full h-full z-65001"
  >
    <div class="bg-white fixed left-1/2 top-1/2 rounded-lg p-4 modal-content">
      <p class="font-medium">
        {{ modalHeaderText }}
      </p>
      <p class="mt-2">
        <input :value="currentLayoutUrl"
               class="block w-full border border-gray-400 rounded p-2 outline-none"
               readonly="readonly"
               type="text"
        >
      </p>
      <p class="mt-3 flex flex-row">
        <button
          class="rounded bg-red-600 hover:bg-gray-600 transition duration-300 text-white uppercase text-base py-2 px-8 cursor-pointer"
          @click="closeClicked"
        >
          Close
        </button>
        <span class="flex-grow"/>
        <button
          class="rounded bg-gray-roc hover:bg-gray-600 transition duration-300 text-white uppercase text-base py-2 px-8 cursor-pointer"
          @click="copyUrlClicked"
        >
          Copy URL
        </button>
      </p>
    </div>
  </div>
</template>

<script>
import copyText from '@/roc/clipboard';

export default {
  props: {
    currentLayoutUrl: {
      type: String,
      required: true
    },
    modalHeaderText: {
      type: String,
      required: true
    }
  },
  setup(props, context) {
    return {
      closeClicked() {
        context.emit('close');
      },

      copyUrlClicked(ev) {
        ev.target.setAttribute('disabled', 'disabled');
        ev.target.classList.remove('hover:bg-gray-600');
        ev.target.classList.remove('cursor-pointer');

        copyText(props.currentLayoutUrl, () => {
          ev.target.innerHTML = 'COPIED!';
        });
      }
    };
  }
};
</script>

<style scoped>
.modal-content {
  width: 600px;
  height: 160px;
  margin-left: -300px;
  margin-top: -80px;
}
</style>
